import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { 
  Box, 
  Paper, 
  Typography, 
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Grid,
  Chip,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { bizpost } from '../../ajax';
import { clone, setConfig, tuples } from '../../core';
import { ProgressDialog } from '../../components/dialogs';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import RoomIcon from '@mui/icons-material/MeetingRoom';
import DeviceIcon from '@mui/icons-material/Devices';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  height: '100%',
  '& .MuiDataGrid-root': {
    border: 'none',
    color: theme.palette.text.primary,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

interface HouseData {
  geo_name: string;
  home_id: number;
  lat: number;
  lon: number;
  name: string;
  role: string;
}

interface RoomData {
  room_id: number;
  name: string;
}

interface DeviceStatus {
  code: string;
  value: any;
}

interface DeviceData {
  active_time?: number;
  biz_type?: number;
  category: string;
  create_time?: number;
  icon?: string;
  id: string;
  ip?: string;
  lat?: string;
  local_key?: string;
  lon?: string;
  model?: string;
  name: string;
  online: boolean;
  owner_id?: string;
  product_id?: string;
  product_name?: string;
  status?: DeviceStatus[];
  sub?: boolean;
  time_zone?: string;
  uid?: string;
  update_time?: number;
  uuid?: string;
}

class HouseOne extends Component<any, any> {
  static propTypes = {
    classes: PropTypes.object,
  };
  static defaultProps: any;
  constructor(props: any) {
      super(props);
      //const { title, service } = this.props;
      //console.log('construct title,service', title, service);
      this.state = {
        title: 'house', 
        url: '/biz',
        params: {t:'house',uid:'eu1753867578433dCt2G'},
        action: '', //'search': can be add,edit,delete,search,...other
        actions: [],
        filter: {},
        loading: false,
        wizmode: 'add',
        record: {},
        data: [],
        recordCount: 0,
        page: 0,
        rowsPerPage: 10,
        pageMode: 'local',
        order: 'desc',
        orderBy: 'dcd',
        refid: null,
        fwopen: false,
        detailDialogOpen: false,
        selectedHouse: null as HouseData | null,
        rooms: [] as RoomData[],
        devices:[] as DeviceData[],
        loadingDetails: false,
      };
    }

  configuration = () => {
    const config = {
      service:{
        name:'house',
        title:'House 1',
        key:'rid',
        num: true,
        fields:['rid','nam','usk','usi','unm','eni','ens','enc','iti','itc','iri','irc','sci','scc','mbn','eml','des','dsc','dcd','exi','sts','ast','stp'],
        params: {nam:'Name',shc:'Code',dsc:'Description',usi:'User',iti:'Monitor Type',iri:'Monitor Role',sci:'Sector',sts:'Status'},
        grid: [['nam','Name'],['mbn','Phone'],['eml','Email'],['des','Designation'],['enc','Entity'],['ast','Status'],['stp','Stamp']],
        bar: {pag:true,btn:['add','edit','del','view']},
        menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
        eform:[
              {id:'iti',label:'Monitor Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectortype'},chs:['nam','usi']},
              {id:'nam',label:'Name',type:'tf',req:0,ops:{},pns:['iti']},
              {id:'sts',label:'Record Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
            ],
      },
      create:true,
      actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
      panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
      formatters: {grid: {exi: (value: any) => value ? JSON.stringify(value) : ''}}
    };
    return config;
  }

  getServiceConfig = () => {
    //const { configuration } = this.props;

    const extraconfig = Object.assign(
      {},
      this.configuration(),
      //configuration()
    );
    const config = setConfig(extraconfig);
    const ServiceConfig = clone(config);
    const SData = ServiceConfig.service;
    return { svc: ServiceConfig, svd: SData };
  };

  setPageMode = () => {
    const { svc, svd } = this.getServiceConfig();
    const { pageMode = 'local' } = svd;
    console.log('setPageMode.pagemode:...', pageMode, svd);
    //console.log("service config",this.getServiceConfig())
    this.setState({ pageMode });
  };

  stopLoading = () => {
    this.setState({ loading: false });
  };

  componentDidMount() {
      // const {svc,svd} = this.getServiceConfig();
      // const {pageMode='local'} = svd;
      // console.log('mounted.pagemode:...',pageMode,svd);
  
      // this.setState({pageMode});
      this.setPageMode();
      console.log('refreshing...');
      this.refresh();
    }
  
    refresh = async (inparams?: any) => {
        console.log('refresh called');
        try {
          const { svc, svd } = this.getServiceConfig();
          const { pageMode = 'local' } = svd;
          // //TODO: store final paramlist in state on success for reuse of refresh
          const { params, rowsPerPage, page } = this.state;
          //const {code,service} = this.props;
          const { service } = this.props;
    
          this.startLoading();
          const pos = page * rowsPerPage;
          const plm = rowsPerPage;
          const paging = pageMode === 'remote' ? { pos, plm } : {};
          let extraparams = inparams || params; //{}
          let baseparams = {
            s: 'api',
            a: 'get',
            ...extraparams,
            ...paging,
          }; /*shc:code,/*,pos:pos,plm:plm*/
          console.log('Refresh params', baseparams);
          const response = await bizpost(baseparams);
          //TODO: build rows and add to state??
          this.setState({ data: response.sd, recordCount: +response.rc }); //,params:baseparams
        } catch (error) {
          // console.log(error);
          this.setState({ data: [] });
          this.setState({ recordCount: 0 });
          console.log('refresh error:', error);
          const errorx: any = error || {};
          this.props.showNotification(
            errorx.message || 'request failed',
            errorx.type || 'warn',
            errorx.title || 'Loading Error'
          );
        } finally {
          if (this.state.loading) this.stopLoading();
        }
      };
  
      startLoading = () => {
      this.setState({ loading: true });
    };

  handleRowClick = (params: any) => {
    const house = params.row as HouseData;
    this.setState({ 
      selectedHouse: house, 
      detailDialogOpen: true,
      rooms: [],
      devices: [],
      loadingDetails: true,
    });
    this.fetchHouseDetails(house.home_id);
  };

  handleCloseDialog = () => {
    this.setState({ 
      detailDialogOpen: false, 
      selectedHouse: null,
      rooms: [],
      devices: [],
    });
  };

  fetchHouseDetails = async (homeId: number) => {
    try {
      const { params } = this.state;
      const uid = params.uid;
      
      // Fetch rooms
      const roomsParams = {
        s: 'api',
        a: 'get',
        t: 'room',
        uid: uid,
        hid: homeId,
      };

      const devicesParams = {
        s: 'api',
        a: 'get',
        t: 'device',
        uid: uid,
        hid: homeId,
      };
      
      // const roomRes = await Promise.all([
      //   bizpost(roomsParams),
      //   bizpost(devicesParams),
      // ]).then(responses => responses);
      const roomsRes = await bizpost(roomsParams);
      //const [roomsRes, devicesRes] = res;
      
      if (roomsRes?.success && roomsRes?.sd) {
        const roomsData = Array.isArray(roomsRes.sd) 
          ? roomsRes.sd 
          : (roomsRes.sd || []);
        
        
        this.setState({ rooms: roomsData });
      } 
      const devicesRes = await bizpost(devicesParams);

      if (devicesRes?.success && devicesRes?.sd) {
        const devicesData = Array.isArray(devicesRes.sd) 
          ? devicesRes.sd 
          : (devicesRes.sd || []);
        
        
        this.setState({ devices: devicesData });
      }
    } catch (error) {
      console.error('Error fetching house details:', error);
      //this.setState({ rooms: [],devices:[] });
      const errorx: any = error || {};
      this.props.showNotification?.(
        errorx.message || 'Failed to load house details',
        errorx.type || 'error',
        errorx.title || 'Error'
      );
    }finally{
      this.setState({ loadingDetails: false });
    }
  };

  render() {
    const {
      url,
      action,
      loading,
      loadingDetails,
      data,
      devices,
      rooms,
      pageMode: pmode,
      page,
      rowsPerPage,
      order,
      orderBy,
    } = this.state;

    const columns: GridColDef<HouseData>[] = [
      {
        field: 'home_id',
        headerName: 'Home ID',
        width: 150,
        type: 'number',
      },
      {
        field: 'name',
        headerName: 'Name',
        width: 200,
        editable: false,
      },
      // {
      //   field: 'role',
      //   headerName: 'Role',
      //   width: 150,
      // },
      {
        field: 'geo_name',
        headerName: 'Geo Name',
        width: 200,
      },
      {
        field: 'lat',
        headerName: 'Latitude',
        width: 120,
        type: 'number',
      },
      {
        field: 'lon',
        headerName: 'Longitude',
        width: 120,
        type: 'number',
      },
    ];

    return (
      <Container>
        <Title>House One</Title>
        <StyledPaper>
          <Box sx={{ height: 600, width: '100%' }}>
            {loading && (
          <ProgressDialog
            open={loading}
            loading={loading}
            startLoading={this.startLoading} //.bind(this)
            stopLoading={this.stopLoading} //.bind(this)
          />
        )}
            <DataGrid
              rows={data}
              columns={columns}
              getRowId={(row) => row.home_id}
              onRowClick={this.handleRowClick}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[5, 10, 25, 50]}
              checkboxSelection
              disableRowSelectionOnClick
              sx={{
                cursor: 'pointer',
                '& .MuiDataGrid-cell:focus': {
                  outline: 'none',
                },
                '& .MuiDataGrid-cell:focus-within': {
                  outline: 'none',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
            />
          </Box>
        </StyledPaper>
        
        {/* House Details Dialog */}
        <Dialog
          open={this.state.detailDialogOpen}
          onClose={this.handleCloseDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: 'background.paper',
              color: 'text.primary',
            }
          }}
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <HomeIcon />
            {this.state.selectedHouse?.name || 'House Details'}
          </DialogTitle>
          <DialogContent dividers>
            {this.state.loadingDetails ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Box>
                {/* House Information */}
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <HomeIcon fontSize="small" />
                    House Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid size={{xs:12,sm:6}}>
                      <Typography variant="body2" color="text.secondary">Home ID</Typography>
                      <Typography variant="body1">{this.state.selectedHouse?.home_id}</Typography>
                    </Grid>
                    <Grid size={{xs:12,sm:6}}>
                      <Typography variant="body2" color="text.secondary">Name</Typography>
                      <Typography variant="body1">{this.state.selectedHouse?.name}</Typography>
                    </Grid>
                    {/* <Grid size={{xs:12,sm:6}}>
                      <Typography variant="body2" color="text.secondary">Role</Typography>
                      <Chip label={this.state.selectedHouse?.role || 'N/A'} size="small" />
                    </Grid> */}
                    <Grid size={{xs:12,sm:6}}>
                      <Typography variant="body2" color="text.secondary">Geo Name</Typography>
                      <Typography variant="body1">{this.state.selectedHouse?.geo_name || 'N/A'}</Typography>
                    </Grid>
                    {(this.state.selectedHouse?.lat || this.state.selectedHouse?.lon) && (
                      <>
                        <Grid size={{xs:12,sm:6}}>
                          <Typography variant="body2" color="text.secondary">Latitude</Typography>
                          <Typography variant="body1">{this.state.selectedHouse?.lat}</Typography>
                        </Grid>
                        <Grid size={{xs:12,sm:6}}>
                          <Typography variant="body2" color="text.secondary">Longitude</Typography>
                          <Typography variant="body1">{this.state.selectedHouse?.lon}</Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Box>

                <Divider sx={{ my: 3 }} />

                {/* Rooms and Devices */}
                <Box>
                  <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* <RoomIcon fontSize="small" /> */}
                    Rooms ({rooms.length})
                  </Typography>
                  
                  {rooms.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                      No rooms found for this house
                    </Typography>
                  ) : (
                    <Box>
                      {rooms.map((room: RoomData, index: number) => (
                        <Box key={room.room_id || index} sx={{ mb: 1 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                              <RoomIcon fontSize="small" />
                              <Typography variant="subtitle1" sx={{ flex: 1 }}>
                                {room.name || `Room ${room.room_id}`}
                              </Typography>
                              {/* {room && room?.length > 0 && (
                                <Chip 
                                  label={`${room?.length} device(s)`} 
                                  size="small" 
                                  color="primary"
                                  variant="outlined"
                                />
                              )} */}
                            </Box>
                        </Box>
                      ))}
                    </Box>
                  )}

                  <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* <RoomIcon fontSize="small" /> */}
                    Devices
                  </Typography>
                  {
                    devices.length === 0 ? (
                      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                        No devices found for this room
                      </Typography>
                    ):(
                    <Box>
                      {
                        devices.map((device: DeviceData, index: number) => (
                          <Paper 
                            key={device.id || index}
                            sx={{ 
                              p: 2, 
                              mb: 2,
                              backgroundColor: 'background.default',
                              border: '1px solid',
                              borderColor: 'divider',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                              <Typography variant="body1" sx={{ fontWeight: 500, flex: 1 }}>
                                {device.name || `Device ${device.id}`}
                              </Typography>
                              <Chip
                                label={device.online ? 'Online' : 'Offline'}
                                size="small"
                                color={device.online ? 'success' : 'warning'}
                                variant="outlined"
                              />
                            </Box>
                            {device.product_name && ( 
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                {device.product_name}
                              </Typography>
                            )}
                            {device.category && (
                              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                Category: {device.category}
                              </Typography>
                            )}
                        
                            </Paper>
                        ))
                      }
                    </Box>
                    )
                  }
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

export default HouseOne;

